<mat-horizontal-stepper #hStepper [linear]="true">
  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>Select Role</ng-template>
    <data-table (custom)="selectRole($event)" [columns]="[{prop: 'name'}]" [dataProvider]="roleService" icon="done">
    </data-table>
    <form [formGroup]="firstFormGroup">
      <input [(ngModel)]="selectedRoleId" formControlName="roleId" required type="hidden">
    </form>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup">
    <ng-template matStepLabel>Select Organisation</ng-template>
    <data-table (custom)="selectOrganisation($event)" [columns]="[{prop: 'name'}]" [dataProvider]="organisationService" icon="done">
    </data-table>
    <form [formGroup]="secondFormGroup">
      <input [(ngModel)]="selectedOrganisationId" formControlName="organisationId" required type="hidden">
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    <div>
      Add Role: {{boundRole?.name}} in Organisation: {{boundOrganisation?.title}}?
    </div>
    <div>
      <button (click)="abort()" color="accent" mat-raised-button>Abort</button>
      <button (click)="save()" color="primary" mat-raised-button>Add</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
